export const LAPTOP_OR_DESKTOP = 1350
export const MOBILE_OR_LAPTOP = 640
export const MOBILE = '640px'
export const WIDE_SCREEN = '2700px'
export const FULL_HD = '1920px'
export const LAPTOP = '1350px'
